import { VerticalProductCardBadge } from "./VerticalProductCardBadge";
import { VerticalProductCardBody } from "./VerticalProductCardBody";
import { VerticalProductCardBrandName } from "./VerticalProductCardBrandName";
import { VerticalProductCardButton } from "./VerticalProductCardButton";
import { VerticalProductCardColorSwatch } from "./VerticalProductCardColorSwatch";
import { VerticalProductCardFooter } from "./VerticalProductCardFooter";
import { VerticalProductCardHeader } from "./VerticalProductCardHeader";
import { VerticalProductCardImage } from "./VerticalProductCardImage";
import { VerticalProductCardPricing } from "./VerticalProductCardPricing";
import { VerticalProductCardProductName } from "./VerticalProductCardProductName";
import { VerticalProductCardRating } from "./VerticalProductCardRating";
import { VerticalProductCardRibbon } from "./VerticalProductCardRibbon";
import { VerticalProductCardRoot } from "./VerticalProductCardRoot";
import { VerticalProductCardVariationName } from "./VerticalProductCardVariationName";
import { VerticalProductCardWishlist } from "./VerticalProductCardWishlist";

export const VerticalProductCard =
  VerticalProductCardRoot as typeof VerticalProductCardRoot & {
    ColorSwatch: typeof VerticalProductCardColorSwatch;
    Header: typeof VerticalProductCardHeader;
    Badge: typeof VerticalProductCardBadge;
    Ribbon: typeof VerticalProductCardRibbon;
    Image: typeof VerticalProductCardImage;
    Wishlist: typeof VerticalProductCardWishlist;
    Button: typeof VerticalProductCardButton;
    Footer: typeof VerticalProductCardFooter;
    Rating: typeof VerticalProductCardRating;
    BrandName: typeof VerticalProductCardBrandName;
    VariationName: typeof VerticalProductCardVariationName;
    ProductName: typeof VerticalProductCardProductName;
    Pricing: typeof VerticalProductCardPricing;
    Body: typeof VerticalProductCardBody;
  };

VerticalProductCard.ColorSwatch = VerticalProductCardColorSwatch;
VerticalProductCard.Header = VerticalProductCardHeader;
VerticalProductCard.Badge = VerticalProductCardBadge;
VerticalProductCard.Ribbon = VerticalProductCardRibbon;
VerticalProductCard.Image = VerticalProductCardImage;
VerticalProductCard.Wishlist = VerticalProductCardWishlist;
VerticalProductCard.Button = VerticalProductCardButton;
VerticalProductCard.Footer = VerticalProductCardFooter;
VerticalProductCard.Rating = VerticalProductCardRating;
VerticalProductCard.BrandName = VerticalProductCardBrandName;
VerticalProductCard.VariationName = VerticalProductCardVariationName;
VerticalProductCard.ProductName = VerticalProductCardProductName;
VerticalProductCard.Pricing = VerticalProductCardPricing;
VerticalProductCard.Body = VerticalProductCardBody;

export type { ProductCardDataType } from "./types";
